module.exports = __webpack_public_path__ + "img/menuIcon22.02172edc.png";